import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import type { DataStore } from "../data";
import { setStepUpHandler } from "../stepUp";
import { StepUpForm } from "../screens/Mfa";

/**
 * The code dialog the store asks for when something needs the code in this session (stepUp.ts), e.g.
 * a photo upload on a remembered device if the storage service did not see the device. After the
 * code the store tries once more; "Mégse" gives the usual "the code is needed" error.
 */
export function StepUpDialog({ store, userId, onDone }: { store: DataStore; userId: string; onDone: () => void }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const resolver = useRef<((ok: boolean) => void) | null>(null);

  useEffect(
    () =>
      setStepUpHandler(
        () =>
          new Promise<boolean>((resolve) => {
            resolver.current?.(false);
            resolver.current = resolve;
            setOpen(true);
          }),
      ),
    [],
  );
  const finish = (ok: boolean) => {
    resolver.current?.(ok);
    resolver.current = null;
    setOpen(false);
    if (ok) onDone();
  };

  if (!open) return null;
  return (
    <div className="modal-backdrop">
      <div className="modal mfa-stepup-dialog" role="dialog" aria-modal="true" aria-labelledby="mfa-stepup-title">
        <h2 id="mfa-stepup-title">{t("mfa.stepUp.title")}</h2>
        <StepUpForm store={store} userId={userId} intro={t("mfa.stepUp.intro")} onDone={() => finish(true)} onCancel={() => finish(false)} />
      </div>
    </div>
  );
}
